/* ══════════════════════════════════════════════════════════════════════════
 * Recraft AI image generation — port of the standalone generator's RecraftAI.js
 *
 * Generates a monoline black-and-white city-skyline logotype for studietur
 * t-shirts. Returns a data-URL (data:image/jpg;base64,...) or null on failure.
 * ══════════════════════════════════════════════════════════════════════════ */

import axios from 'axios';

const RECRAFT_API_KEY = 'Gn1gbq46OZ5a5YhMf2mL7bP3qbcLNrJwmeG8vX12VOJ5NbGS9MNmhuWtF9gs62Zu';
const RECRAFT_URL = 'https://external.api.recraft.ai/v1/images/generations';

const IMAGE_PROMPT =
  '- Monoline vector black-and-white logotype of **{{CITY}}** city with most popular sightseeings.\n' +
  '{{EXTRA_PROMPT}}\n\n' +
  '**Style:**\n' +
  '**Minimalistic outline monoline black-and-white vector illustration** - clean, uniform lines, no shading or textures.\n\n' +
  '**Lighting:**\n' +
  'Flat, high-contrast: pure black lines on white background, no implied light source or shading.\n\n' +
  '**Color Palette:**\n' +
  '- Strokes: pure black\n' +
  '- Background: pure white\n' +
  '- No other colors, gradients, tints, or textures.\n\n' +
  '**Technical Details:**\n' +
  '- Constant monoline stroke width of **10 px** throughout.\n' +
  '- Vector format for clean scaling.\n\n' +
  '**Additional Elements:**\n' +
  '- No overly complex details.\n' +
  '- Keep overall element count low\n';

// The class is deliberately NOT part of the prompt — it is drawn on the school
// line instead ("2G • Roskilde Gymnasium"), where it renders cleanly rather than
// being hand-lettered by the model.
const HAS_YEAR = "- The hand-lettered texts: '**{{YEAR}}**' and '**{{CITY}}**'";
const NO_YEAR = "- The hand-lettered texts: '**{{CITY}}**'";

export async function getRecraftImage(city, year) {
  try {
    const extraPrompt = year
      ? HAS_YEAR.replace('{{YEAR}}', year).replaceAll('{{CITY}}', city)
      : NO_YEAR.replaceAll('{{CITY}}', city);

    const prompt = IMAGE_PROMPT.replace('{{EXTRA_PROMPT}}', extraPrompt).replaceAll('{{CITY}}', city);

    const response = await axios.post(
      RECRAFT_URL,
      {
        prompt,
        style: 'digital_illustration',
        n: 1,
        size: '1024x1024',
        model: 'recraftv3',
        response_format: 'b64_json',
      },
      {
        headers: {
          Authorization: `Bearer ${RECRAFT_API_KEY}`,
          'Content-Type': 'application/json',
        },
      }
    );

    if (response?.data?.data?.length > 0) {
      const image = response.data.data[0].b64_json;
      return 'data:image/jpg;base64,' + image;
    }
    console.warn('No images generated by RecraftAI. Returning null.');
    return null;
  } catch (error) {
    console.error('Error generating image with RecraftAI:', error);
    return null;
  }
}
